// export const API_BASE_URL = "http://localhost:8080";
export const API_BASE_URL = "http://mergejil-songolt.edu.mn";
export const CLIENT_BASE_URL = "http://localhost:3000";
